import { render } from "./phoneDelivery.vue?vue&type=template&id=2b33a1af"
import script from "./phoneDelivery.vue?vue&type=script&lang=js"
export * from "./phoneDelivery.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/marketing/phoneDelivery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b33a1af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b33a1af', __exports__)) {
    console.log('reload')
    api.reload('2b33a1af', __exports__)
  }
  
  module.hot.accept("./phoneDelivery.vue?vue&type=template&id=2b33a1af", () => {
    console.log('re-render')
    api.rerender('2b33a1af', render)
  })

}


export default __exports__